import React from 'react'
import styled from 'styled-components'

import Container from 'react-bootstrap/Container';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';

// import Logo from './../../common/components/Logo'
// import Socials from './Socials'

const Wrapper = styled.div`
  background-color: #1a237e;
  background-position: top left;
  background-repeat: repeat-x;

  color: #ffffff;

`;
// const Top = styled.div`
//   padding-top: 100px;
//   padding-bottom: 40px;
// `;
const Bottom = styled.div`
  padding-top: 20px;
  padding-bottom: 25px;
  text-align: center;
  // border-top: 1px solid #ffffff;
`;

const Footer = () => {
  return (
    <Wrapper>
      <Container>
        <Bottom>
          ©{(new Date().getFullYear())} ACS Autoriparazioni Camper Service di Meneghel Mirko e Meneghel Juri e C SAS | Riparazioni meccaniche auto e furgoni dal 1999<br/>
          <small>Sede legale: Via dell'Alpino, 22 - 46031 San Biagio di Bagnolo San Vito (MN) - P. IVA: 01892860204 - PEC: a.c.s.autofficina@legalmail.it - <a href="https://www.iubenda.com/privacy-policy/45603536" rel="noreferrer" target="_blank">Privacy Policy</a> - <a href="https://www.iubenda.com/privacy-policy/45603536/cookie-policy" rel="noreferrer" target="_blank">Cookie Policy</a></small>
        </Bottom>
      </Container>
    </Wrapper>
  )
}

export default Footer
